import { useTranslation } from "react-i18next";
import HelpPanel from "@cloudscape-design/components/help-panel";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";

function AppHelpPanel({ activeTabId }) {
  const { t } = useTranslation();

  return (
    <HelpPanel header={<Box variant="h2">{t("venue.help.panel.title")}</Box>}>
      <SpaceBetween size="l">
        {/* 1. About this demo */}
        <div>
          <Box variant="h3">{t("venue.help.panel.about_title")}</Box>
          <Box variant="p">{t("venue.help.panel.about_description")}</Box>
        </div>

        {/* 2. How it works */}
        <div>
          <Box variant="h3">{t("venue.help.panel.how_it_works_title")}</Box>
          <Box variant="p">
            {t("venue.help.panel.how_it_works_steps")
              .split("\n")
              .map((step, i) => (
                <span key={i}>
                  {step}
                  <br />
                </span>
              ))}
          </Box>
        </div>

        <hr />

        {/* 3. Page-by-page explanations */}
        <div>
          <Box variant="h3">{t("venue.help.dashboard.title")}</Box>
          <Box variant="p">{t("venue.help.dashboard.description")}</Box>
        </div>

        <div>
          <Box variant="h3">{t("venue.help.documents.title")}</Box>
          <Box variant="p">{t("venue.help.documents.description")}</Box>
          <SpaceBetween size="s">
            <Box variant="p" color="text-body-secondary" padding={{ top: "xs" }}>
              • {t("venue.help.documents.upload_hint")}
            </Box>
            <Box variant="p" color="text-body-secondary">
              • {t("venue.help.documents.custom_prompt_hint")}
            </Box>
          </SpaceBetween>
        </div>

        <div>
          <Box variant="h3">{t("venue.help.configuration.title")}</Box>
          <Box variant="p">{t("venue.help.configuration.description")}</Box>
        </div>

        <div>
          <Box variant="h3">{t("venue.help.document-types.title")}</Box>
          <Box variant="p">{t("venue.help.document-types.description")}</Box>
        </div>

        <hr />

        {/* 4. Tips */}
        <div>
          <Box variant="h3">{t("venue.help.panel.tips_title")}</Box>
          <SpaceBetween size="xs">
            <Box variant="p" color="text-body-secondary">
              • {t("venue.help.panel.tip_auto_detect")}
            </Box>
            <Box variant="p" color="text-body-secondary">
              • {t("venue.help.panel.tip_custom_prompt")}
            </Box>
            <Box variant="p" color="text-body-secondary">
              • {t("venue.help.panel.tip_bulk")}
            </Box>
            <Box variant="p" color="text-body-secondary">
              • {t("venue.help.panel.tip_reprocess")}
            </Box>
          </SpaceBetween>
        </div>
      </SpaceBetween>
    </HelpPanel>
  );
}

export default AppHelpPanel;
